import React from "react"

import { useScrollController } from "features/scroll-management/model/useScrollController"

import { ProjectTeamInvitationListPageView } from "./ProjectTeamInvitationListPageView"
import { ProjectTeamInvitationListPageModel } from "./types/ProjectTeamInvitationListPageModel"

export interface ProjectTeamInvitationListPageProps
  extends ProjectTeamInvitationListPageModel {}

export const ProjectTeamInvitationListPage = React.memo(
  (props: ProjectTeamInvitationListPageProps) => {
    useScrollController()

    return <ProjectTeamInvitationListPageView {...props} />
  }
)
